<template>
  <div class="layout-container">
    <div class="view-container">
      <v-row no-gutters class="mt-10">
        <v-col class="info-title" cols="12">
          <p class="font--m-1" style="line-height: 1.4">정보 등록 (1/2)</p>
          <p class="font--m-5 color--gray-80" style="line-height: 1.4">
            앞으로 후불결제 서비스를 이용하실 사장님의 <br />실제 사업장 정보를 입력해주세요
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters class="mb-10">
        <v-col cols="12">
          <p class="mb-1 font--m-5">스토어명</p>
          <v-text-field
            v-model="store.name"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.name"
            label="쇼핑몰 이름 입력"
          ></v-text-field>
          <ErrorText :text="invalidMsg.name" nudgeLeft="4" />
        </v-col>
        <v-col cols="12" class="position--relative mt-5">
          <p class="mb-1 font--m-5">사업장 주소</p>
          <div class="mt-3 mb-3">
            <BasicButton
              width="73px"
              height="35px"
              @click="daumAddrOpen = !daumAddrOpen"
              id="btn__NikCMR9RT0Ki1cv2zEJVQQ=="
            >
              주소 검색
            </BasicButton>
          </div>
          <DaumAddr :isOpen.sync="daumAddrOpen" @update:addr="oncompleteAddr" class="mt-2" />
          <v-text-field
            v-model="store.address1"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.address1"
            label="주소검색"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <ErrorText :text="invalidMsg.address1" nudgeLeft="4" />
          <p class="mt-5 mb-1 font--m-5">상세 주소</p>
          <v-text-field
            v-model="store.address2"
            ref="address2"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.address2"
            label="상세주소 입력"
          ></v-text-field>
          <ErrorText :text="invalidMsg.address2" nudgeLeft="4" />
        </v-col>
        <v-col cols="12">
          <p class="mt-5 mb-1 font--m-5">쇼핑몰 URL</p>
          <v-text-field
            v-model="store.url"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.url"
            :rules="rules.url"
            label="쇼핑몰 접속 주소 입력 ex. www.buy-now.kr"
          ></v-text-field>
          <ErrorText :text="invalidMsg.url" nudgeLeft="4" />
        </v-col>
      </v-row>
      <v-row no gutters class="mb-10">
        <v-col cols="12">
          <BasicButton
            id="btn__icxCFMpNHkSbKJOO87twwg=="
            :disabled="!isValidAll || isLoading"
            :loading="isLoading"
            @click="addStore(store)"
          >
            다음
          </BasicButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Regex from '@/const/Regex'
import DaumAddr from '@/components/address/DaumAddr.vue'

export default {
  components: { DaumAddr },
  data() {
    return {
      daumAddrOpen: false,
      store: {
        name: null,
        address1: null,
        address2: null,
        url: null,
      },
      isLoading: false,
      rules: {
        name: [(value) => !!value || '상호명을 입력해주세요'],
        address1: [(value) => !!value || '주소를 입력해주세요'],
        address2: [(value) => !!value || '상세 주소를 입력해주세요'],
        url: [
          (value) => !!value || '쇼핑몰 주소를 입력해주세요',
          (value) => Regex.URL.REGEX.test(value) || Regex.URL.MSG,
        ],
      },
      invalidMsg: {},
      nameIsValid: false,
      address1IsValid: false,
      address2IsValid: false,
      urlIsValid: false,
    }
  },
  computed: {
    isValidAll() {
      return (
        this.nameIsValid === true &&
        this.address1IsValid === true &&
        this.address2IsValid === true &&
        this.urlIsValid === true
      )
    },
  },
  watch: {
    'store.name'(v) {
      // 상호명 중복 검사
      this.nameDuplicate(v)
    },
    'store.address1'(v) {
      const msg = this.getFormErrMsg('address1', v)
      this.address1IsValid = msg === null
    },
    'store.address2'(v) {
      const msg = this.getFormErrMsg('address2', v)
      this.address2IsValid = msg === null
    },
    'store.url'(v) {
      // 쇼핑몰 url 중복 검사
      this.urlDuplicate(v)
    },
    'isValidAll': {
      immediate: true,
      handler(v) {
        if (v === true) {
          this.$emit('update:store', this.store)
        } else {
          this.$emit('update:store', null)
        }
      },
    },
  },
  methods: {
    ...mapActions('store', {
      inputStore: 'addStore',
    }),
    ...mapActions('auth', ['getMe']),
    async addStore(store) {
      this.isLoading = true
      try {
        await this.inputStore(store)
        await this.getMe()
        await this.$router.push({ name: 'my/business/register' })
      } finally {
        this.isLoading = false
      }
    },
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      if (newVal) {
        for (let index = 0; index < rules.length; index++) {
          const rule = rules[index]
          const isValid = rule(newVal)
          if (typeof isValid !== 'boolean') {
            msg = isValid
            break
          }
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    nameDuplicate(name) {
      const msg = this.getFormErrMsg('name', name)
      if (msg === null) {
        this.nameIsValid = true
      } else {
        this.nameIsValid = false
      }
    },
    urlDuplicate(url) {
      const msg = this.getFormErrMsg('url', url)
      if (msg === null) {
        this.urlIsValid = true
      } else {
        this.urlIsValid = false
      }
    },
    oncompleteAddr(addrObj) {
      this.store.address1 = addrObj.address
      this.$nextTick((_) => {
        this.$refs.address2.focus()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.view-container {
  .info-title {
    text-align: center;
  }
}
</style>
